<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 17:17:09
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-21 09:48:06
-->
<template>
    <div>
       <el-dialog
    title="高级搜索"
    :visible.sync="dialogVisible"
    width="1100px"
    :before-close="close"
    top="3vh"
  >
    <div>
      <div class="search">
        <div class="left">
          <a-row>
            <a-col class="a-col" :span="6">
              <span style="margin-left:0" class="label-title">站点范围</span>
              <el-select class="selelct" v-model="siteType" placeholder="请选择">
                <el-option label="多站点" value="2"> </el-option>
                <el-option label="本站点" value="1"> </el-option>
              </el-select>
            </a-col>
            <a-col class="a-col" :span="6">
              <span class="label-title">搜索范围</span>
              <el-select class="selelct" v-model="searchType" placeholder="请选择">
                <el-option label="仅标题" value="1"> </el-option>
                <el-option label="仅正文" value="2"> </el-option>
                <el-option label="标题及正文" value="3"> </el-option>
              </el-select>
            </a-col>
            <a-col class="a-col" :span="6">
              <span class="label-title">时间范围</span>
              <el-select class="selelct" v-model="timeType" placeholder="请选择">
                <el-option label="一周内" value="1"> </el-option>
                <el-option label="一个月内" value="2"> </el-option>
                <el-option label="半年内" value="3"> </el-option>
                <el-option label="一年内" value="4"> </el-option>
                <el-option label="全部" value="5"> </el-option>
              </el-select>
            </a-col>
            <a-col class="a-col" :span="6">
              <span class="label-title">搜索内容</span>
              <el-input
                class="selelct"
                v-model="searchValue"
                placeholder="请输入搜索内容"
              ></el-input>
            </a-col>
          </a-row>
        </div>
        <div class="right">
          <el-button @click="search" style="margin-left:24px;background: #176de6;" type="primary">查询</el-button>
        </div>
      </div>
      <div class="body">
        <a-spin :spinning="loadingLeft">
            <div class="body-left">
          <div class="body-title">找到{{total}}条内容，共{{itemSerch.hitNumber || 0}}处</div>
          <div class="text">
            <div @click="itemOne(item)" v-for="item in resData" class="text-one">
               <div class="title" v-if="item.titleHeight" v-html="item.titleHeight"></div>
               <div class="title" v-if="!item.titleHeight">{{item.title}}</div>
               <div v-if="item.contentHeight" class="content" v-html="item.contentHeight"></div>
               <div v-if="!item.contentHeight" class="content"  v-html="item.content"></div>
               <div class="time">
                  <div>{{item.createTime}}</div>
                  <div>{{item.state == 0
            ? "草稿"
            : item.state == 1
            ? "审核中"
            : item.state == 2
            ? "审核通过"
            : item.state == 3
            ? "审核失败"
            : item.state == 4
            ? "已发布"
            : "下线"}}</div>
               </div>
            </div>
          </div>
          <div class="page">
            <a-pagination  size="small" @change="change" v-model="current"  :page-size.sync="size" :total="total" show-less-items />
            <div>共{{total}}条</div>
          </div>
          <div class="footer">
            <el-button  v-if="codeData.indexOf('173') != -1" style="border-color:#176de6;color:#176de6"  @click="batchReplacementFn" type="primary" plain>批量替换</el-button>
          </div>
        </div>
        </a-spin>
        
        <div class="body-right">
          <div class="cont-box">
              <div v-if="!itemDel.titleHeight" class="content-title">{{itemDel.title}}</div>
          <div v-if="itemDel.titleHeight" class="content-title" v-html="itemDel.titleHeight"></div>
          <div class="content-time">
              <div class="cont-time">发布时间: {{itemDel.createTime}}</div>
              <div class="cont-name">编辑: {{itemDel.updateUserName}}</div>
          </div>
          <div v-if="!itemDel.contentHeight" class="cont-text" v-html="itemDel.content"></div>
          <div v-if="itemDel.contentHeight" class="cont-text" v-html="itemDel.contentHeight"></div>
          </div>
          <div class="footer">
            <div class="operation">
              <a-row>
                <a-col class="a-col" :span="7">
                  <span class="label">查找内容</span>
                  <el-input
                    v-model="value"
                    placeholder="请输入搜索内容"
                  ></el-input>
                </a-col>
                <a-col class="a-col" :span="7">
                  <span style="width: 80px" class="label">替换为</span>
                  <el-input
                    v-model="replaceAfter"
                    placeholder="请输入搜索内容"
                  ></el-input>
                </a-col>
                <a-col :span="4">
                  <el-button @click="replaceAll" style="margin-left: 24px;background: #176de6;" type="primary"
                    >全部替换</el-button
                  >
                </a-col>
                <a-col :span="4">
                  <el-button @click="toPath" style="margin-left: 60px;border-color:#176de6;color:#176de6" type="primary" plain
                    >编辑内容</el-button
                  >
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
      title="批量替换"
      :visible.sync="dialogVisibleColum"
      width="535px"
      class="column-box"
      :before-close="handleCloseColum"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >对搜索结果列表中的所有内容执行关键词替换
      </div>
      <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="查找内容">
        <el-input
          v-model="ruleForm.value"
          placeholder="请输入查找内容"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="替换为">
        <el-input
          v-model="ruleForm.replaceAfter"
          placeholder="请输入替换内容"
        ></el-input>
      </el-form-item>
    </el-form>
     <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisibleColum = false">取 消</el-button>
    <el-button :loading="loadingBtn" type="primary" @click="replaceResults">批量替换</el-button>
  </span>
  </el-dialog>

  <el-dialog
      title="确定替换？"
      :visible.sync="dialogVisiblEnd"
      width="535px"
      class="column-box"
      :before-close="huiTui"
      top="12%"
    >
     {{tipsTxt}}
     <span slot="footer" class="dialog-footer">
    <el-button   @click="huiTui">取消</el-button>
    <el-button v-if="codeData.indexOf('174') != -1" :loading="loadingBtnTwo" type="primary" @click="tihuan">确定</el-button>
  </span>
  </el-dialog>
    </div>
</template>

<script>
import {heightSearch,selectHeightById,batchReplacement,replaceAllManuscript,fallback,countBatchReplacement } from '../all_manuscripts'
export default {
  props: ["visible"],
  data() {
    return {
      dialogVisible: false,
      siteType: "1",
      searchType: "1",
      timeType: "1",
      searchValue: "",
      current: 1,
      resData:[],
      total:0,
      size:10,
      loadingLeft:false,
      item:'',
      value:'',
      replaceAfter:'',
      itemDel:{},
      dialogVisibleColum:false,
      ruleForm:{
        replaceAfter:'',
        value:'',
      },
      dialogVisiblEnd:false,
      endData:{},
      itemSerch:{},
      tipsTxt:'',
      loadingBtn:false,
      loadingBtnTwo:false,
      codeData:[],
    };
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getList()
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    toPath(){
      let routeData =  this.$router.resolve({
        path: "/index/content/manuscripts_edit",
        query: {
           id: this.item.id,
            title: "编辑稿件",
            islast: true,
            type: 1,
        },
      });
       window.open(routeData.href, '_blank');
    },
    handleCloseColumEnd(){
      this.dialogVisiblEnd = false;
    },
    close() {
      this.$emit("close");
    },
    handleCloseColum(){
        this.dialogVisibleColum = false;
    },
    replaceAll(){
        replaceAllManuscript({
          value:this.value,
          replaceAfter:this.replaceAfter,
          id:this.item.id,
        }).then((res)=>{
           if(res.code == 0){
              this.getList()
              this.getDel();
           }
        })
    },
    batchReplacementFn(){
      this.ruleForm.value = this.searchValue;
      this.dialogVisibleColum = true;
    },
    replaceResults(){
      this.loadingBtn = true;
        countBatchReplacement({
            siteType:this.siteType,
            searchType:this.searchType,
            timeType:this.timeType,
            searchValue:this.searchValue,
            siteId:sessionStorage.getItem('siteId'),
            value:this.ruleForm.value,
            replaceAfter:this.ruleForm.replaceAfter,
        }).then((res)=>{
            if(res.code == 0){
                this.tipsTxt = res.data.message;
                this.dialogVisibleColum = false;
                 this.dialogVisiblEnd = true;
                  this.loadingBtn = false;
            }else{
              this.loadingBtn = false;
            }
        })
    },
    tihuan(){
       this.loadingBtnTwo = true;
         batchReplacement({
           siteType:this.siteType,
            searchType:this.searchType,
            timeType:this.timeType,
            searchValue:this.searchValue,
            siteId:sessionStorage.getItem('siteId'),
            value:this.ruleForm.value,
            replaceAfter:this.ruleForm.replaceAfter,
        }).then((res)=>{
            if(res.code == 0){
              this.dialogVisibleColum = false;
               this.dialogVisiblEnd = false;
              this.searchValue = '';
              this.endData = res.data;
              this.ruleForm.replaceAfter=''
              this.ruleForm.value=''
               this.loadingBtnTwo = false;
              this.getList();
              this.getDel();
            }
        })
    },
    huiTui(){
      // fallback({
      //   ...this.endData,
      // }).then((res)=>{
      //     if(res.code == 0){
      //         this.dialogVisiblEnd = false;
      //            this.getList();
      //           this.getDel();
      //     }
      // })
        this.dialogVisiblEnd = false;
    },
    fishThuan(){
        this.getList();
        this.getDel();
        this.dialogVisiblEnd = false;
    },
    getList(){
      this.loadingLeft = true;
      heightSearch({
        siteType:this.siteType,
        searchType:this.searchType,
        timeType:this.timeType,
        searchValue:this.searchValue,
        siteId:sessionStorage.getItem('siteId'),
        current:this.current,
        size:this.size,
      }).then((res)=>{
            if(res.code == 0){
               this.loadingLeft = false;
                this.resData = res.data.records;
                 if(res.data.records.length > 0){
                    if(!this.item){
                       this.item = res.data.records[0];
                    }
                    this.itemSerch = res.data.records[0];
                    this.getDel();
                }
                this.total = res.data.total;
            }
      })
    },
    search(){
      this.current = 1;
      this.getList();
      this.getDel();
    },
    change(page){
       this.current = page;
       this.item = '';
       this.getList();
    },
    itemOne(item){
      this.item = item;
      this.getDel()
    },
    getDel(){
       selectHeightById({
        id:this.item.id,
        value:this.searchValue,
        type:this.searchType,
      }).then((res)=>{
          if(res.code == 0){
              this.itemDel = res.data;
          }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  padding: 32px 0px 0px 0px;
  display: flex;
  .body-left {
    width: 375px;
    height: 680px;
    border: solid 2px #dedede;
    border-radius: 4px;
    position: relative;
    .body-title {
      background: #f7f7f7;
      padding: 6px 20px;
      color: #000;
      border-bottom: solid 2px #dedede;
    }
    .text {
      padding: 12px;
      height: 512px;
      overflow-y: auto;
      .text-one {
        border-bottom: solid 2px #f1f1f1;
        margin-top: 20px;
        padding-bottom: 20px;
        cursor: pointer;
      }
    }
    .page {
      position: absolute;
      bottom: 74px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 12px;
      /deep/ .ant-pagination-item-active {
        background: #1890ff;
      }
      /deep/ .ant-pagination-item-active a {
        color: #fff;
      }
    }
  }
  .body-right {
    flex: 1;
    height: 680px;
    width: 600px;
    margin-left: 24px;
    border: solid 2px #dedede;
    border-radius: 4px;
    position: relative;
    .cont-box{
       padding-left: 64px;
  padding-right: 64px;
    }
   
    .operation {
      display: flex;
      justify-content: center;
      /deep/ .el-input__inner {
        background: #fff;
      }
    }
  }
}
/deep/ .el-dialog__title {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}


.search {
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
  }
  /deep/ .el-input__inner {
  background: #f7f7f7;
}
}
.a-col {
  display: flex;
  align-items: center;
}
.label {
  margin-left: 24px;
  color: #000;
  width: 110px;
}
.label-title{
     color: #000;
      width: 80px;
       margin-left: 12px;
       margin-right: 12px;
}
.a-col:last-child{
    .label-title{
         width: 110px;
    }
}
.footer {
  padding: 6px;
  padding-left: 12px;
  background: #f7f7f7;
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: solid 2px #dedede;
}
.title{
  color: rgba(16, 16, 16, 1);
  font-size: 13px;
  font-family: Roboto-regular;
  text-overflow: -o-ellipsis-lastline;
	overflow: hidden;				//溢出内容隐藏
	text-overflow: ellipsis;		//文本溢出部分用省略号表示
	display: -webkit-box;			//特别显示模式
	-webkit-line-clamp: 2;			//行数
	line-clamp: 2;					
	-webkit-box-orient: vertical;	//盒子中内容竖直排列
}
.content{
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: Roboto-regular;
  text-overflow: -o-ellipsis-lastline;
	overflow: hidden;				//溢出内容隐藏
	text-overflow: ellipsis;		//文本溢出部分用省略号表示
	display: -webkit-box;			//特别显示模式
	-webkit-line-clamp: 2;			//行数
	line-clamp: 2;					
	-webkit-box-orient: vertical;	//盒子中内容竖直排列
  margin-top: 20px;
}
.time{
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
}
.content-title{
  color: rgba(48, 49, 51, 1);
  font-size: 23px;
  font-family: Roboto-regular;
  font-weight: 600;
  margin-top: 42px;
  margin-bottom: 20px;
}
.content-time{
  display: flex;
  justify-content: space-between;
}
.content-title{
  
}
.cont-text{
  margin-top: 20px;
  overflow: auto;
  height: 450px;
   
}
.cont-time,.cont-name{
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.demo-ruleForm{
  margin-top: 24px;
}
/deep/ .el-button--primary.is-plain:hover{
   background:#ecf5ff;
}
/deep/ .el-dialog__body{
  padding-top: 20px;
}
</style>